import React from 'react';
import Field from '../../Field';
import StepFooter from './StepFooter';
import { CATEGORY_UNSET_LABEL } from '../../../domain/expenses';
import s from '../import.module.css';

export default function PasteStep({
  text, onTextChange, fileName, hasHeader, onHasHeaderChange,
  expenseCategories, revenueCategories, defaultExpense, defaultRevenue,
  onDefaultExpenseChange, onDefaultRevenueChange,
  onBack, onCancel, onNext,
}) {
  return (
    <div className={s.imCard}>
      <div className={s.imStep}>Step 2/4</div>

      <Field label={fileName
        ? `Loaded from ${fileName}`
        : 'Paste your expenses and revenue here (CSV format)'}>
        <textarea
          rows={9}
          className={`${s.imCtl} ${s.paste}`}
          value={text}
          onChange={(e) => onTextChange(e.target.value)}
        />
      </Field>

      <label className={s.checkRow}>
        <input type="checkbox" checked={hasHeader} onChange={(e) => onHasHeaderChange(e.target.checked)} />
        <span className={s.checkLabel}>Use the first row as the column header</span>
      </label>

      {/* "Not Specified" is the empty state here too, not a choice (#134, #116):
          the same `disabled hidden` markup as the add/edit form's Category
          select (EntryFormDrawer has why both), so it shows while nothing is
          chosen and is gone from the list once opened.

          Choosing a default is optional: a file whose own Category column names
          a category for every row needs none. What is not possible is choosing
          the absence of one and having fifty rows land under it. */}
      <div className={s.divider}>
        <Field label="Default Expense Category">
          <select className={s.imCtl} value={defaultExpense} onChange={(e) => onDefaultExpenseChange(e.target.value)}>
            <option value="" disabled hidden>{CATEGORY_UNSET_LABEL}</option>
            {expenseCategories.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
        </Field>
      </div>

      <Field label="Default Revenue Category">
        <select className={s.imCtl} value={defaultRevenue} onChange={(e) => onDefaultRevenueChange(e.target.value)}>
          <option value="" disabled hidden>{CATEGORY_UNSET_LABEL}</option>
          {revenueCategories.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
      </Field>

      <div className={s.imHint}>
        Used only for rows whose own Category column is empty. A row left with no category
        at all is not imported — you will see which in the preview.
      </div>

      <StepFooter onBack={onBack} onCancel={onCancel} onNext={onNext} nextDisabled={!text.trim()} />
    </div>
  );
}
